import React,{ useState,useEffect } from 'react';
import ReactDOM from 'react-dom';



const HowToUse = (props) => {



   const howToUseName = {
      position: 'absolute',
      // left: '109px',
      top: '28px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '24px',
      lineHeight: '36px',
      display: 'flex',
      alignItems: 'center',
      color: '#000000',
      tabIndex: '1'

   }
   const useImages = {
      position: 'fixed',

      height: '498px',
      width: '381px',
      top: '185px',
      border: '1px solid #EEEEEE',
      boxShadow: '0px 2px 2px rgb(0 43 85 / 8%), 0px 4px 4px rgb(0 43 85 / 8%), 0px 8px 8px rgb(0 43 85 / 8%), 0px 16px 16px rgb(0 43 85 / 8%), 0px 32px 32px rgb(0 43 85 / 8%)',
      borderRadius: '10px',
      background: '#FFFFFF',
      // display: 'none'
      opacity: 0,
      transition: "opacity 2s",
      // visibility: 'Hidden',
      tabIndex: '1'

   }
   const howToUseImages = {
      position: 'absolute',
      left: '50%',
      top: '56%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      width: '260px',
      tabIndex: '1'

   }
   const UseImagesIpad = {
      position: 'fixed',
      left: '-351px',

      border: '1px solid #EEEEEE',
      boxShadow: '0px 2px 2px rgb(0 43 85 / 8%), 0px 4px 4px rgb(0 43 85 / 8%), 0px 8px 8px rgb(0 43 85 / 8%), 0px 16px 16px rgb(0 43 85 / 8%), 0px 32px 32px rgb(0 43 85 / 8%)',
      borderRadius: '10px',
      background: '#FFFFFF',
      opacity: 0,
      transition: "opacity 2s",
      display: 'flex',
      top: '0.5%',
      justifyContent: 'center',
      marginTop: 0

   }
   const howToUseDiv = {
      width: '100%',
      textAlign: 'center',
      lineHeight: '40px',
      fontSize: '30px'
   }
   const useName1 = {
      position: 'absolute',
      width: '90px',
      height: '28px',
      left: '0',
      top: '30px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: ['ko','de','es','fr','fr-ca','nl'].includes(props?.data?.langcode) ? '20px':['pl'].includes(props?.data?.langcode) ? '19px':'24px',
      lineHeight: '36px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
      color: '#000000',
      wordBreak: ['de','es','pl','nl'].includes(props?.data?.langcode) ? 'normal' : 'break-all',
   }
   const useName2 = {
      position: 'absolute',
      width: '90px',
      height: '28px',
      left: '0',
      top: '120px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: ['ko','de','es','fr','fr-ca','nl'].includes(props?.data?.langcode)? '20px':['pl'].includes(props?.data?.langcode) ? '19px':'24px',
      lineHeight: '36px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
      color: '#000000',
      wordBreak: ['fr','fr-ca'].includes(props?.data?.langcode) ? 'normal' : 'break-all',
   }
   const useName3 = {
      position: 'absolute',
      width: '90px',
      height: '28px',
      left: '0',
      top: '215px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: ['ko','de','es','fr','fr-ca','nl'].includes(props?.data?.langcode) ? '20px':['pl'].includes(props?.data?.langcode) ? '19px' : '24px',
      lineHeight: '36px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
      color: '#000000',
      wordBreak: ['de','ko','pl'].includes(props?.data?.langcode) ? 'normal' : 'break-all'
   }
   const imgUse = {
      marginTop: '22px',
      marginLeft: '100px',
      height: '54px',
      width: '127px'
   }
   const closeUse = {
      position: 'absolute',
      right: '10px',
      top: '10px',
      color: 'rgb(204, 204, 204)',
      height: '20px',
      width: '20px',
      cursor: 'pointer',
   }
   const usestyle = {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '16px',
      position: 'relative',
      left: '17px',
      top: '-4px'
   }
   const iconStyle = {
      transform: ' rotate(180deg)',
      position: 'relative',
      left: '0',
      top: '2px',
      color: '#006BBD',
      height: '22px',
      width: '22px'
   }
   const closePop = {
      padding: '5px',
      textAlign: 'center',
      position: 'absolute',
      right: '2px',
      top: '-13px',
      color: 'rgb(204, 204, 204)',
      height: '18px',
      width: '20px',
      border: '1px solid #dbdddf'


   }
   let { howToUSE,move,rotate,zoom } = { ...props.data };


   return (
      <React.Fragment>
         {ReactDOM.createPortal(
            <div id="howToUSE" tabIndex="-1" style={UseImagesIpad} className="useImg">
               <span tabIndex="-1" style={howToUseName}>{howToUSE !== undefined ? howToUSE : 'How to use'} </span>

               <div style={howToUseImages}>
                  <div tabIndex="-1" style={howToUseDiv}><span style={useName1}>{move !== undefined ? move : 'Move'}</span><img style={imgUse} alt="Move by swiping with two fingers on touchscreen or by clicking the right mouse button" src="images/move.svg" /></div>
                  <div tabIndex="-1" style={howToUseDiv}><span style={useName2}>{rotate !== undefined ? rotate : 'Rotate'} </span><img style={imgUse} alt="Rotate by making a circular motion with one finger on touchscreen or by clicking the left mouse button" src="images/rotate.svg" /></div>
                  <div tabIndex="-1" style={howToUseDiv}><span style={useName3}>{zoom !== undefined ? zoom : 'Zoom'}</span><img style={imgUse} alt="Zoom by using two fingers to pinch and expand or by using the scroll wheel on the mouse" src="images/zoom.svg" /></div>
               </div>
               <p className="closePop"  style={closePop} tabIndex="-1" onKeyPress={(e) => props.closeHandle(e)} onClick={(e) => props.closeHandle(e)} id="closeBtn"><img  alt="closeBtn" src="images/cross.svg" /></p>
            </div>,
            document.getElementById('howTousePopupDesk')

         )}
      </React.Fragment>
   )
}



export default HowToUse;

